<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="mb-4">
            <v-col
              cols="12">
              <div
                class="d-flex align-center">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="30">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-2"
                    style="font-weight: 600;">
                    Konfig Gaji
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="4">
              <ValidationProvider 
                name="Tunjangan Jabatan" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  
                  Tunjangan Jabatan
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Tampil"

                  hide-details

                  :items="[
                    {
                      text: 'Tampil',
                      value: '1'
                    },
                    {
                      text: 'Tidak Tampil',
                      value: '0'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.tun_jabatan"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.tun_jabatan !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="4">
              <ValidationProvider 
                name="Tunjangan Keahlian" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  
                  Tunjangan Keahlian
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Tampil"

                  hide-details

                  :items="[
                    {
                      text: 'Tampil',
                      value: '1'
                    },
                    {
                      text: 'Tidak Tampil',
                      value: '0'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.tun_keahlian"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.tun_keahlian !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="4">
              <ValidationProvider 
                name="Tunjangan Luar Kota" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  
                  Tunjangan Luar Kota
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Tampil"

                  hide-details

                  :items="[
                    {
                      text: 'Tampil',
                      value: '1'
                    },
                    {
                      text: 'Tidak Tampil',
                      value: '0'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.tun_luar_kota"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.tun_luar_kota !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>

          </v-row>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        unit: [],
        position: [],

        picker: {
          join: false
        },

        message: {
          check: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.position_id': function() {
        let self = this
        let data = this.position.filter(function(v) {
          return self.form.position_id == v.id
        })

        if (data.length > 0) {
          this.form.position = data[0].title
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      // this.fetchUnit()
    },
    methods: {
      async fetchUnit () {
        let params = {
          limit: 100000
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
            
            if (this.$route.query.unit_id !== undefined) this.form.unit_id = this.$route.query.unit_id

            this.fetchPosition()
          }
        })
      },

      async fetchPosition () {
        let params = {
          limit: 100000,
          unit_id: this.form.unit_id,

          par_id: this.$route.params.id === undefined && this.$route.query.position_id !== undefined ? this.$route.query.position_id : ''
        }

        await get('admin/user_position/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.position = res.results.data
          }
        })
      },

      async fetchCheck () {
        let params = {
          search: this.form.code
        }

        await get('admin/user/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let total = res.results.data.length

            this.message.check = total > 0 ? 'sudah digunakan' : ''
          }
        })
      }
    }
  }
</script>